import { Factory } from '../Factory';
import { Service } from '../Service';

export class ReportService extends Service<any> {
  private configService: any;
  private tokenService: any;

  constructor(resource: any, rootScope: IRootScope, configService: any, resourceWrapperService, tokenService: any, notificationService: any) {
    super({resource, rootScope, resourceWrapperService});

    this.configService = configService;
    this.tokenService = tokenService;

    let raw = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/report/:id`,
      {id: "@id", projectId: "@projectId"},
      {
        update: {method: "PUT"},
        query: {method: "GET", params: {page: 1, limit: 50}, isArray: false}
      });

    this.itemResource = this.resourceWrapperService.WrapActions(raw);

    // ReportComplete / ReportUpdate are handled in React
    // (src/hooks/useReports -> WebSocketBridge), including the audit-tracked
    // download toast.
  }

  public Find(projectId, page, limit, filter, callback) {
    return this.itemResource.query({
      projectId: projectId,
      page: page,
      limit: limit,
      filter: filter
    }, (reportsPage) => {
      // Fill up our on-page cache
      this.items.length = 0;
      angular.forEach(reportsPage.reports, (report) => {
        this.items.push(report);
      });

      if (callback) callback(reportsPage);
    });
  }
}

frontendApp.factory("ReportService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "TokenService", "NotificationService", Factory.Create(ReportService)]);
